import React from "react";
import { Nav, Form, Button, } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { BoxArrowRight, PersonCircle, House, Truck, PlusCircle, Moon, Sun, People, FileSpreadsheet, Table } from "react-bootstrap-icons";

const Navi = ({ tema, toggleTema, restrans }) => {
  const location = useLocation();
  const { user, logout } = useAuth();

  // Helper pentru a randa link-urile rapid și curat
  const NavItem = ({ to, icon: Icon, label, colorClass = "" }) => (
    <Nav.Item>
      <Nav.Link
        as={Link}
        to={to}
        active={location.pathname === to}
        className={`d-flex align-items-center custom-nav-link ${colorClass} ${
          restrans ? "justify-content-center" : ""
        }`}
        style={{ height: "45px", transition: "all 0.2s ease" }}
      >
        <Icon size={20} style={{ minWidth: "20px" }} />
        {!restrans && (
          <span className="ms-3 text-nowrap opacity-fade-in">{label}</span>
        )}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <div className="d-flex flex-column h-90 p-2 overflow-hidden">
      {/* SECȚIUNEA DE SUS: NAVIGARE */}
      <Nav variant="pills" className="flex-column mb-auto gap-1">
        <NavItem to="/" icon={House} label="Panou central" />
        <NavItem to="/Situatie-exploatare" icon={Table} label="Situatie exploatare"/>
        <NavItem to="/prestari" icon={Truck} label="Vezi contracte" />
        <NavItem to="/tabelPartizi" icon={FileSpreadsheet} label="Tabel partizi"/>
        <NavItem to="/adaugPartida" icon={PlusCircle} label="Partizi" />
        <NavItem to="/adaug" icon={PlusCircle} label="Adaugă contract" />
        {user?.rol === "administrator" && (
          <>
            <div className="border-top mt-2 opacity-50"></div>
            <NavItem to="/admin-utilizatori" icon={People} label="Utilizatori"/>
          </>
        )}
      </Nav>

      {/* SECȚIUNEA DE MIJLOC: SWITCH TEMĂ */}
      <div className="mt-auto border-top pt-3 ms-1">
        <div
          className={`d-flex align-items-center mb-3 px-2 ${
            restrans ? "justify-content-center" : "justify-content-between"
          }`}
          style={{ height: "30px" }}
        >
          {!restrans && (
            <div className="d-flex align-items-center opacity-fade-in">
              {tema === "light" ? (
                <Sun className="text-warning me-2" />
              ) : (
                <Moon className="text-primary me-2" />
              )}
              <span className="small fw-medium">
                {tema === "light" ? "Light" : "Dark"}
              </span>
            </div>
          )}
          <Form.Check
            type="switch"
            id="theme-switch"
            checked={tema === "dark"}
            onChange={toggleTema}
            className="custom-switch"
            style={{ cursor: "pointer", margin: 0 }}
          />
        </div>

        {/* SECȚIUNEA DE JOS: PROFIL ȘI LOGOUT */}
        <div
          className={` border-top p-2 bg-light-soft mb-2 ${
            restrans ? "text-center align-items-center" : "d-flex align-items-center"
          }`}
        >
          <PersonCircle
            size={restrans ? 28 : 24}
            className="text-success flex-shrink-0"
          />
          {!restrans && (
            <div className="ms-2 overflow-hidden opacity-fade-in">
              <p className="fw-bold small mb-0 text-truncate">
                {user?.nume || "Utilizator"}
              </p>
              <p
                className="mb-0 text-truncate"
                style={{ fontSize: "0.65rem", textTransform: "uppercase" }}
              >
                {user?.rol}
              </p>
            </div>
          )}
        </div>

        <Button
          variant="outline-danger"
          size="sm"
          onClick={logout}
          className={`d-flex align-items-center border-0 ${
            restrans
              ? "justify-content-center mx-auto"
              : "w-100 px-3 justify-content-between"
          }`}
          style={{ height: "40px", borderRadius: "8px" }}
        >
          <BoxArrowRight size={18} />
          {!restrans && (
            <span className="ms-2 fw-bold opacity-fade-in">Ieșire</span>
          )}
        </Button>
      </div>
    </div>
  );
};

export default Navi;
